import { useMemo } from 'react';

import { useStatusContext } from 'pages/Status/context';

import {
  LINE_2_DELIVERY,
  LINE_2_STANDARD,
  SUBTITLE_ARRAY,
  SUBTITLE_ARRAY_DELIVERY,
} from './constants';

interface ReadyToStartHook {
  subtitleArray: string[];
  line2: string;
  isLoading: boolean;
}

export default function useCancelled(): ReadyToStartHook {
  const { jobCompanyInfo, isLoading, isDeliveryOnly } = useStatusContext();

  const companyName = useMemo(() => {
    if (!jobCompanyInfo || isLoading) return 'Your tradesperson';
    return jobCompanyInfo?.company_name || 'Your tradesperson';
  }, [jobCompanyInfo, isLoading]);

  const subtitleArray = useMemo(() => {
    const base = isDeliveryOnly ? SUBTITLE_ARRAY_DELIVERY : SUBTITLE_ARRAY;
    return base.map((part) => part.replace('$partner', companyName));
  }, [isDeliveryOnly, companyName]);

  const line2 = useMemo(() => {
    const base = isDeliveryOnly ? LINE_2_DELIVERY : LINE_2_STANDARD;
    return base.replace('$partner', companyName);
  }, [isDeliveryOnly, companyName]);

  return {
    subtitleArray,
    line2,
    isLoading,
  };
}
